<main class="films-page" *ngIf="view$ | async as view">
  <section
    class="video-player col"
    *ngIf="view?.selectedVideo"
    data-test="film-container"
  >
    <div class="container player-container">
      <flo-video-player
        floScrollToElementOnNavigation
        [video]="view?.selectedVideo.video"
        [isAutoPlayed]="true"
        [isPlaylist]="true"
        (played)="onPlayed(view?.nextVideoId)"
      >
      </flo-video-player>
      <div id="desc" data-test="description-container">
        <h2 class="video-title" data-test="film-title">{{
          view?.selectedVideo?.video?.title
        }}</h2>
        <span class="flo-footnote" data-test="film-date">{{
          view?.selectedVideo?.date | date
        }}</span>
        <div [ngSwitch]="view?.selectedVideo?.isRich">
          <p
            id="dynamic-content"
            class="video-description full-content"
            data-test="film-description"
            *ngSwitchCase="true"
            [innerHTML]="view?.selectedVideo?.description | floSanitizeHtml"
            floDynamicContent
          ></p>
          <p id="plain-content" class="video-description" *ngSwitchCase="false">
            {{ view?.selectedVideo?.description }}</p
          >
        </div>
      </div>
    </div>
  </section>
  <section class="associated-videos col" *ngIf="view?.associatedVideos.length">
    <div class="associated-videos-container">
      <section>
        <flo-carousel
          [headingText]="view.seriesTitle"
          [itemIndex]="view.nextVideoIndex"
          border="bottom"
        >
          <a
            class="carousel-element associated-video"
            *ngFor="
              let video of view?.associatedVideos;
              trackBy: trackByVideo;
              let i = index
            "
            (click)="onVideoSelectionChange(video)"
            [class.selectedVideo]="video === view?.selectedVideo.video"
          >
            <div class="spotlight-wrapper">
              <flo-spotlight
                class="dark-theme"
                [title]="video.title"
                [imageUrl]="video.asset_url"
                [duration]="video.duration"
                [premium]="video.premium"
                [publishDate]="video.publish_start_date | isoStringToDate"
                [playingVideo]="video === view?.selectedVideo.video"
                [lightProBadge]="true"
                [smallThumbnail]="true"
              ></flo-spotlight>
            </div>

          </a>
        </flo-carousel>
      </section>
    </div>
  </section>
  <section class="video-grid">
    <div class="container films-container px-lg-4">
      <div class="row" data-test="film-container">
        <div class="d-flex justify-content-between py-3 align-items-md-center align-items-sm-start films-search-header">
          <h1 class="h3 mb-0 text-capitalize" data-test="film-header">All Films</h1>
          <div class="films-search">
            <flo-search-input-next-gen
              [searchTerm]="view.searchTerm"
              (search)="handleSearch($event)"
              [debounce]="500"
              data-test="films-search-desktop"
              >
            </flo-search-input-next-gen>
          </div>
        </div>

        <section class="col-lg-12">
          <flo-video-grid
            [videos]="view?.videos"
            [notFoundWarning]="view?.notFoundWarning"
            queryParamsHandling="merge"
            [queryParamsFn]="view?.queryParamsFn"
            fullScreen="col-md-3"
          ></flo-video-grid>
          <br />
          <div class="d-flex justify-content-center" *ngIf="view?.canLoadMore">
            <button
              floAnalytics
              name="See More"
              class="btn-primary btn btn-lg"
              data-test="see-more"
              (click)="onPage(view?.meta.page + 1)"
              >See More</button
            >
          </div>
        </section>
      </div>
    </div>
  </section>
</main>
